import React, { useEffect, useState } from "react";
import {
  Button,
  IconButton,
  Tooltip,
  Switch,
} from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Select, MenuItem, FormControl, InputLabel, Typography } from "@mui/material";
import AddTaxSlab from "./AddTaxSlab";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import ExportButton from "../../components/ag grid/ExportButton";
import usePermission from "../../utils/usePermission";
import TaxApiViewController from "../../redux/actions/TaxSlabApiAction";

const TaxSlabListPage = () => {
  const dispatch = useDispatch();
  const gridRef = React.useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const { hasPermission } = usePermission();

  const { getTaxSlab, deleteTaxSlab, updateTaxSlab } = TaxApiViewController();
  const { tax_slab } = useSelector((state) => state.taxslab); // Replace with your reducer name

  useEffect(() => {
    dispatch(getTaxSlab());
  }, []);

  const refreshList = () => dispatch(getTaxSlab());

  const handleDelete = (id) => dispatch(deleteTaxSlab(id));
  const openModalForCreate = () => {
    setEditData(null);
    setShowModal(true);
  };
  const openModalForEdit = (data) => {
    setEditData(data);
    setShowModal(true);
  };

const [selectedYear, setSelectedYear] = useState("2025-2026");
const [regime, setRegime] = useState("Old Regime");

useEffect(() => {
  const now = new Date();
  const currentMonth = now.getMonth(); // 0 = Jan, 3 = Apr
  const currentYear = now.getFullYear();

  if (selectedYear === "2024-2025") {
    setRegime("Old Regime");
  } else if (selectedYear === "2025-2026") {
    if (currentYear > 2025 || (currentYear === 2025 && currentMonth >= 3)) {
      setRegime("New Regime");
    } else {
      setRegime("Old Regime");
    }
  }
}, [selectedYear]);


  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      pinned: "left",
      width: 50,
    },
    {
      headerName: "SR No.",
      valueGetter: "node.rowIndex + 1",
      width: 80,
    },
    { headerName: "Minimum Range", field: "min_income", flex: 1 },
    {
      headerName: "Maximum Range",
      field: "max_income",
      flex: 1,
    },
    {
      headerName: "Tax Rate",
      field: "tax_rate",
      flex: 1,
      valueFormatter: (params) => `${params.value}%`,
    },
    {
      headerName: "Fixed Tax",
      field: "fixed_tax",
      flex: 1,
      valueFormatter: (params) => `₹${params.value}`,
    },
    {
      headerName: "Actions",
      field: "actions",
      flex: 1,
      cellRenderer: (params) => (
        <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
            <Tooltip title="Edit">
              <IconButton size="small" onClick={() => openModalForEdit(params.data)}>
                <Edit sx={{ color: "#555" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton size="small" onClick={() => handleDelete(params.data.id)}>
                <Delete sx={{ color: "#d32f2f" }} />
              </IconButton>
            </Tooltip>
          
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex mb-3" style={{ justifyContent: "space-between" }}>
        <div className="mt-2">
          
            <Button
              variant="contained"
              startIcon={<AddCircleOutline />}
              onClick={openModalForCreate}
              sx={{ borderRadius: "8px", textTransform: "none", px: 2 }}
            >
              Add Tax Slab
            </Button>
          
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
         
            <ExportButton
              gridRef={gridRef}
              fileName="Tax_Slabs.xlsx"
              exportColumns={["location", "regime", "min_income", "max_income", "tax_rate", "fixed_tax"]}
              disabled={selectedRows.length === 0}
            />
          
          <PageSizeSelector
            pageSize={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          />
        </div>
      </div>
      <div className="label-card">
  <Row className="justify-content-between w-100 align-items-center">
    <Col className="d-flex align-items-center gap-3">
      <h3 className="mb-0">Tax Slab List</h3>
      </Col>
      <Col className="d-flex justify-content-end gap-3">
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="year-select-label">Year</InputLabel>
        <Select
          labelId="year-select-label"
          value={selectedYear}
          label="Year"
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          <MenuItem value="2025-2026">2025-2026</MenuItem>
          <MenuItem value="2024-2025">2024-2025</MenuItem>
        </Select>
      </FormControl>
      {/* <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Regime: {regime}
      </Typography> */}
    </Col>
  </Row>
</div>

      <div className="list-grid-container" style={{ height: "70vh" }}>
        <ReusableGrid
          columnDefs={columnDefs}
          rowData={Array.isArray(tax_slab) 
          ? tax_slab.filter((item) => item.regime === (regime === "Old Regime" ? "old" : "new"))
          : []}

          gridRef={gridRef}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
          pagination={true}
          pageSize={pageSize}
        />
      </div>

      <AddTaxSlab
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editData}
        refreshList={refreshList}
      />
    </div>
  );
};

export default TaxSlabListPage;
